module.exports = __webpack_public_path__ + "img/7.e6f60d3c.svg";